import { useContext } from "react";
import { useFormik } from "formik";
import { InitiativeContext } from "../../contexts/InitiativeContextProvider";
import { WorkStreamDataSchema } from "../../utils/validations";
import { updateWorkstream } from "../../api/Api";
import { showToast } from "../../utils/toastUtils";
import ModalUI from "../ui/ModalUI";
import ShortTextInput from "../Inputs/ShortTextInput";
import TextAreaInput from "../Inputs/TextAreaInput";
import CustomButton from "../CustomButton";

function UpdateWorksreamModal({ show, handleClose, initiative, projectId, refresh }) {
  // const { refresh } = useContext(InitiativeContext);

  const formik = useFormik({
    initialValues: {
      name: initiative?.name || "",
      description: initiative?.description || "",
      projectId: projectId || "",
      start_date: initiative?.start_date
        ? new Date(initiative.start_date).toISOString().split("T")[0]
        : "",
      end_date: initiative?.end_date
        ? new Date(initiative.end_date).toISOString().split("T")[0]
        : "",
    },
    validationSchema: WorkStreamDataSchema,
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true);

      const payload = {
        name: values.name,
        description: values.description,
        projectId: values.projectId,
        start_date: values.start_date,
        end_date: values.end_date,
      };

      updateWorkstream(initiative.id, payload)
        .then((response) => {
          if (response.status === 200) {
            showToast("Workstream updated successfully", "success");
            refresh();
            handleClose();
          }
        })
        .catch((error) => {
          console.error("Failed to update workstream:", error);
          showToast("Failed to update workstream. Please try again.", "error");
        })
        .finally(() => setSubmitting(false));
    },
    enableReinitialize: true,
  });

  return (
    <ModalUI show={show} handleClose={handleClose} title="Update WorkStream">
      <form onSubmit={formik.handleSubmit}>
        <ShortTextInput
          id="name"
          label="Name"
          name="name"
          placeholder="Enter WorkStream Name"
          value={formik.values.name}
          onChange={formik.handleChange}
          error={formik.touched.name && formik.errors.name}
        />
        <TextAreaInput
          id="description"
          label="Description"
          name="description"
          placeholder="Enter WorkStream Description"
          value={formik.values.description}
          onChange={formik.handleChange}
          error={formik.touched.description && formik.errors.description}
        />
        <ShortTextInput
          id="start_date"
          label="Start Date"
          name="start_date"
          type="date"
          value={formik.values.start_date}
          onChange={formik.handleChange}
          error={formik.touched.start_date && formik.errors.start_date}
        />
        <ShortTextInput
          id="end_date"
          label="End Date"
          name="end_date"
          type="date"
          value={formik.values.end_date}
          onChange={formik.handleChange}
          error={formik.touched.end_date && formik.errors.end_date}
        />
        <div className="d-flex justify-content-center p-3">
          <CustomButton disabled={formik.isSubmitting} type="submit">
            {formik.isSubmitting ? "Updating..." : "Update"}
          </CustomButton>
        </div>
      </form>
    </ModalUI>
  );
}

export default UpdateWorksreamModal;
